<template>
	<BaseEventDetail v-slot="{item}">
		<CmsIntroContainer :page="item">
			<template #h1>
				<h1 v-if="item?.seo_h1">{{ item.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>

		<section class="main">
			<div class="wider-wrapper">
				<div class="main-content">
					<div class="cms-content">
						<div class="pd-hero-image" v-if="item?.main_image">
							<a :href="item.main_image" class="fancybox" rel="gallery" :title="item.title">
								<BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width920-height736']" default="/images/no-image-485.jpg" :alt="item.main_image_description" />
							</a>
						</div>

						<p class="ed-date">
							<BaseCmsLabel code="event_duration_to" tag="strong" />
							<template v-if="item.date"> <BaseUtilsFormatDate :date="item.date" format="DD.MM.YYYY." /></template>
							<template v-if="item.time"> u {{item.time}}h</template>
							<template v-if="item.date_end"> do <BaseUtilsFormatDate :date="item.date_end" format="DD.MM.YYYY." /></template>
							<template v-if="item.time_end"> u {{item.time_end}}h</template>
							<template v-if="item.location">
								<br><BaseCmsLabel code="event_location" tag="strong" /> {{item.location}}
							</template>
						</p>

						<div v-if="item?.content" v-html="wrapInnerBtn(item.content)" v-interpolation />
					</div>
				</div>
				
				<CmsSidebar />
			</div>
		</section>
	</BaseEventDetail>
</template>